import React, { useState } from "react";
import { getLanguageTexts, getSelectedLanguage } from "../../language";

const TextReadMore = props => {

    const [readmore, SetReadMore] = useState(false);
    const t = getLanguageTexts(getSelectedLanguage());

    return(
        <div>
            <props.element className="break-word overflow-hidden" style={props.style}>
                <b style={{float: "left", marginRight: "2px"}}>{props.title} </b>
                {props.html==true &&<br/>}
                {props.html==undefined && <div style={{whiteSpace:'pre-line '}}>
                    {(readmore ? props.children : props.children.substring(0, props.limit) + (props.children.length > props.limit ? "..." : ""))}
                </div>}

                {props.html==true && <div className="jodit-wysiwyg" dangerouslySetInnerHTML={{__html: props.children}}>
                    {/* {(readmore ? props.children : props.children.substring(0, props.limit) + (props.children.length > props.limit ? "..." : ""))} */}
                </div>}
            </props.element>
            <>
                {(props.children.length > props.limit
                     ? (<a className="text-event" onClick={() => SetReadMore(!readmore)}>{(readmore ? t.show_less : t.show_more)}</a>)
                     : ""
                )}
            </>
        </div>
    );
}

export default TextReadMore;
